import { CheckCircledIcon, Flex, Typography } from '@iheartjane/reefer';

export const SuccessConfirmationScreen = () => {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      gap={16}
      justifyContent="center"
      width="100%"
      height="100vh"
      px={24}
    >
      <CheckCircledIcon size="xxl" color="primary" />
      <Typography branded textAlign="center" variant="h2-semibold">
        Your bank account has been linked
      </Typography>
      <Typography textAlign="center">
        Go back to the kiosk and start shopping!
      </Typography>
    </Flex>
  );
};
